var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.clickable
    ? _c("div", { staticClass: "payment-card", class: _vm.classes }, [
        _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
        _c("div", { staticClass: "shine" }),
      ])
    : _c(
        "div",
        {
          staticClass: "payment-card clickable",
          class: _vm.classes,
          on: {
            click: function ($event) {
              return _vm.onClick($event)
            },
          },
        },
        [
          _c("div", { staticClass: "content" }, [_vm._t("default")], 2),
          _c("div", { staticClass: "shine" }),
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }